/**
 * Inserts newlines between GFM table rows that were merged onto one line by the model.
 */
export function repairCollapsedMarkdownTables(markdown: string): string {
  const repairLine = (line: string): string => {
    const trimmed = line.trim();
    if (!trimmed.includes('|') || trimmed.startsWith('```')) {
      return line;
    }
    if ((trimmed.match(/\|/g) ?? []).length < 4) {
      return line;
    }
    let repaired = trimmed;
    let previous = '';
    while (repaired !== previous) {
      previous = repaired;
      repaired = repaired.replace(/\|\s+\|(?=\s*[-:`a-zA-Z0-9_])/g, '|\n|');
    }
    return repaired;
  };

  return markdown
    .split('\n')
    .flatMap((line) => repairLine(line).split('\n'))
    .join('\n');
}
